module.exports = __webpack_public_path__ + "static/FOTO_1-125ad31c29a6fc1303178b8fffab3081.png";